import { render, staticRenderFns } from "./ModeratorForm.vue?vue&type=template&id=3717b7a0&scoped=true&"
import script from "./ModeratorForm.vue?vue&type=script&lang=js&"
export * from "./ModeratorForm.vue?vue&type=script&lang=js&"
import style0 from "./ModeratorForm.vue?vue&type=style&index=0&id=3717b7a0&scoped=true&lang=css&"
import style1 from "./ModeratorForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3717b7a0",
  null
  
)

export default component.exports